import { useEffect } from 'react';
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import { Separator } from '../../utils/utils';

const Table = ({ item, setItem, activeAccordion, validations }) => {
    //   let activeAccordion = 'Intake Form';
    const { handleChangeHeader, handleChangeRows, handleAddRow, handleDeleteRow } = useNewItemChange(setItem, 'Viewer', activeAccordion);
    const headers = item.headers ? item.headers.split(Separator) : [];
    const rows = item.rows ?
        item.rows?.split("\n") ? item.rows?.split("\n") : item.rows?.split("\n") :
        [];
    const rowCount = Number(item.noOfRows) || rows.length || 1;
    // useEffect(() => {
    //     if (JSON.stringify(rows) === JSON.stringify(item.rows)) {
    //         return; // No change, so exit early
    //     }
    //     setItem(prev => {
    //         return prev.map(section => {
    //             if (section.key === activeAccordion) {
    //                 const updatedItems = section.items.map(currItem => {
    //                     if (currItem.ItemID === item.ItemID) {
    //                         let defaultRows = '';
    //                         Array.from({ length: item.noOfRows || 0 }).forEach((_, index, arr) => {
    //                             defaultRows += Array.from({ length: item.noOfHeaders - 1 || 0 }).map(() => Separator).join('');
    //                             if (index < arr.length - 1) defaultRows += '\n'; // Only add '\n' if it's NOT the last row
    //                         });
    //                         return { ...currItem, rows: defaultRows };
    //                     }
    //                     return currItem;
    //                 });
    //                 return { ...section, items: updatedItems };
    //             }
    //             return section;
    //         });
    //     });
    // }, [])
    console.log("item123Table",item)
    return (
        <div className='table-view template-acordian d-flex gap-10'>
            <p className={`text text-black w-231px d-flex  justify-content-end gap-01 text-end flex-shrink-0 ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
                {item?.content || "[Enter prompt or question]"}
                {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>}
            </p>
            <div className="d-flex flex-column gap-6 min-w-0">
            <div className="overflow-auto w-100">
                <table className='templates-table output' >
                    <thead>
                        <tr>
                            {headers.length > 0 ?
                                (headers.map((header, index) => (
                                    <th key={index} className='text-black font-m fw-500 text w-auto'>
                                        {header || `[Insert Column Header ${index + 1}]`}
                                    </th>
                                ))) : <th className='text-black font-m fw-500 text w-auto'>[Insert Column Header 1]</th>}
                            {rowCount > 1 && (<th className="min-w-0"></th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: item.noOfRows || 2 }).map((_, rowIndex) => (
                            <tr key={rowIndex}>
                                {console.log("TableViewer", rows)}
                                {(rows?.[rowIndex] || "")?.split(Separator).map((rowItem, cellIndex) => (
                                    <td key={cellIndex}>
                                        <div className="input h-100">
                                            <input
                                                type="text"
                                                value={rowItem}
                                                onChange={(e) => handleChangeRows(item, e, rowIndex, cellIndex)}
                                                className='form-control border-0 text-black font-r'
                                            />
                                        </div>
                                    </td>)
                                )}
                                {rowCount > 1 &&
                                    (<td><i className="icon-delete ar-light-color fs-11" onClick={() => handleDeleteRow(item, rowIndex)}></i></td>)}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="d-flex align-items-center gap-6">
                <button className='btn btn-ar-add px-2' onClick={() => handleAddRow(item)}>
                    <i className="icon-plus-feesetup theme-clr fs-9"></i> Add Row
                </button>
            </div>
            </div>
        </div >
    );
};

export default Table